// Calendar helpers for weekly recurring classes (America/Toronto).
const BYDAY = { SUN: "SU", MON: "MO", TUE: "TU", WED: "WE", THU: "TH", FRI: "FR", SAT: "SA" };
const DOW = { SUN: 0, MON: 1, TUE: 2, WED: 3, THU: 4, FRI: 5, SAT: 6 };
const TZ = "America/Toronto";

const pad = (n) => String(n).padStart(2, "0");

function nextDate(day) {
  const now = new Date();
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diff = (DOW[day] - d.getDay() + 7) % 7;
  d.setDate(d.getDate() + diff);
  return d;
}

function fmt(dateObj, hh, mm, addMin = 0) {
  let total = hh * 60 + mm + addMin;
  const dayOffset = Math.floor(total / 1440);
  total = ((total % 1440) + 1440) % 1440;
  const h = Math.floor(total / 60);
  const m = total % 60;
  const d = new Date(dateObj);
  d.setDate(d.getDate() + dayOffset);
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(h)}${pad(m)}00`;
}

export function displayTime(start) {
  const [h, m] = start.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  const hr = ((h + 11) % 12) + 1;
  return `${hr}:${pad(m)} ${ap}`;
}

export function googleCalUrl(cls) {
  const [hh, mm] = cls.start.split(":").map(Number);
  const d = nextDate(cls.day);
  const start = fmt(d, hh, mm, 0);
  const end = fmt(d, hh, mm, cls.duration_min || 60);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `${cls.name} — Getfitwithjeanclaude`,
    dates: `${start}/${end}`,
    details: cls.description || "",
    location: cls.address || cls.location || "",
    ctz: TZ,
    recur: "RRULE:FREQ=WEEKLY;BYDAY=" + BYDAY[cls.day],
  });
  return "https://calendar.google.com/calendar/render?" + params.toString();
}

export function downloadIcs(cls) {
  const [hh, mm] = cls.start.split(":").map(Number);
  const d = nextDate(cls.day);
  const start = fmt(d, hh, mm, 0);
  const end = fmt(d, hh, mm, cls.duration_min || 60);
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Getfitwithjeanclaude//Class Schedule//EN",
    "BEGIN:VEVENT",
    `UID:${cls.id}@getfitwithjeanclaude`,
    `DTSTART;TZID=${TZ}:${start}`,
    `DTEND;TZID=${TZ}:${end}`,
    "RRULE:FREQ=WEEKLY;BYDAY=" + BYDAY[cls.day],
    `SUMMARY:${cls.name} — Getfitwithjeanclaude`,
    `DESCRIPTION:${cls.description || ""}`,
    `LOCATION:${cls.address || cls.location || ""}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(cls.name || "class").replace(/[^a-z0-9]+/gi, "-")}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
